import type { Config } from '@/core/types'
import { FeatureFlags } from '@/services/types'

export type ProdConfig = Omit<Config, 'toolbar'>

export type CoreUrlsConfig = {
  appUrl: string
  apiUrl: string
  socketUrl: string
}

const getConfig = (envSource = import.meta.env): ProdConfig => ({
  env: 'prod',
  appUrl: envSource.VUE_APP_APP_URL,
  apiUrl: envSource.VUE_APP_API_URL,
  telemetryUrl: envSource.VUE_APP_TELEMETRY_URL,
  socketUrl: envSource.VUE_APP_WIRE_URL,
  logger: {
    enabled: false,
    loggerRules: {},
    channels: {},
  },
  sentry: {
    dsn: envSource.VUE_APP_SENTRY_DSN ?? '',
    timeout: Number(envSource.VUE_APP_SENTRY_TIMEOUT) || 2000,
    maskSelectors: ['input[name=password]'],
    unMaskSelectors: ['*'],
  },
  monitoring: {
    key: envSource.VUE_APP_MONITORING_KEY,
  },
  tracking: {
    forceTracking: envSource.VUE_APP_FORCE_TRACKING === 'true',
    trackSignUp: envSource.VUE_APP_TRACK_SIGN_UP === 'true',
    zendeskKey: envSource.VUE_APP_ZENDESK_KEY,
    googleAnalyticsMeasurementKey: envSource.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_KEY,
    firstPromoterId: envSource.VUE_APP_FIRST_PROMOTER_ID,
    firstPromoterHost: envSource.VUE_APP_FIRST_PROMOTER_HOST,
    postHogUrl: envSource.VUE_APP_POSTHOG_URL,
    postHogKey: envSource.VUE_APP_POSTHOG_KEY,
  },
  featureFlags: {
    [FeatureFlags.ComposeEmailPromoModal]: envSource.VUE_APP_COMPOSE_EMAIL_PROMO_MODAL === 'true',
    [FeatureFlags.EmailBonus]: envSource.VUE_APP_EMAIL_BONUS === 'true',
    [FeatureFlags.EntriDomainPurchase]: envSource.VUE_APP_ENTRI_DOMAIN_PURCHASE === 'true',
    [FeatureFlags.ComposeEmailChooseEditorModal]: envSource.VUE_APP_COMPOSE_EMAIL_CHOOSE_EDITOR_MODAL === 'true',
    [FeatureFlags.AutomationAiBuilder]: envSource.VUE_APP_AUTOMATION_AI_BUILDER === 'true',
    [FeatureFlags.ZendeskWidget]: envSource.VUE_APP_ZENDESK_WIDGET === 'true',
    [FeatureFlags.NewLoginPage]: envSource.VUE_APP_NEW_LOGIN_PAGE === 'true',
    [FeatureFlags.NewAuthPages]: envSource.VUE_APP_NEW_AUTH_PAGES === 'true',
    [FeatureFlags.SentryVerboseLogging]: envSource.VUE_APP_SENTRY_VERBOSE_LOGGING === 'true',

    // [FeatureFlags.Folders]: envSource.VUE_APP_FOLDERS === 'true',
  },
})

export default getConfig
